import { Component } from '@angular/core';

@Component({
  selector: 'icon-normal-screen',
  standalone: true,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M4 14H10M10 14V20M10 14L3 21M20 10H14M14 10V4M14 10L21 3" stroke="#F8F9FA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `,
  styles: `
    @import '../assets/colors.scss';

    svg{
        cursor: pointer;
        path{
          stroke: $text_header_color
        }
    }
  `
})

export class NormalScreenIconComponent {}
